import { CSSProperties, Component, ReactNode, createElement } from "react";

import { Language } from "@/model/Language/Language";
import { TranslationConsumer } from "@/model/Translation/TranslationContext";

export interface ITranslateProps {
  String: string;
  className?: any;
}

interface IHtmlTagTranslateProps extends ITranslateProps {
  id?: string;
  htmlFor?: string;
  HTMLTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "label" | "li" | "p";
  style?: CSSProperties;
}

export function GetLanguageValueAsString(
  ctx: Language | null,
  key: string,
  value: string,
) {
  if (ctx !== null) {
    const string = ctx.Strings.filter((k) => k.Key === key);
    return string.length > 0 ? string[0].Value : value;
  }

  return value;
}

export function GetLanguageValue(
  ctx: Language | null,
  key: string,
  value: string | ReactNode,
): { value: string | ReactNode; missingTranslationKey: string } {
  let message = "";
  if (ctx !== null) {
    const string = ctx.Strings.filter((k) => k.Key === key);
    value = string.length > 0 ? string[0].Value : value;
    if (string.length === 0) {
      message = key;
    }
  }

  return { value, missingTranslationKey: message };
}

export class Translate extends Component<IHtmlTagTranslateProps, any> {
  renderTranslation(ctx: Language | null) {
    let val = this.props.children;
    let message = "";
    if (ctx !== null) {
      const string = ctx.Strings.filter((k) => k.Key === this.props.String);
      val = string.length > 0 ? string[0].Value : val;
      if (string.length === 0) {
        message = this.props.String;
      }
    }

    return createElement(
      this.props.HTMLTag ? this.props.HTMLTag : "span",
      {
        id: this.props.id,
        className: this.props.className,
        htmlFor: this.props.htmlFor,
        title: message,
        style: this.props.style,
      },
      val,
    );
  }

  render() {
    return (
      <TranslationConsumer>
        {(ctx: Language | null) => this.renderTranslation(ctx)}
      </TranslationConsumer>
    );
  }
}
